import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { PieChartComponent } from './chart-types/pie-chart/pie-chart.component';


@NgModule({
  declarations: [
    PieChartComponent
  ],
  imports: [
    CommonModule,
    NgChartsModule
  ],
  exports: [
    PieChartComponent,
    NgChartsModule
  ]
})
export class DataChartModule { }
